import React, { useState, useEffect } from 'react';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';
import DatePeriodControl from './DatePeriodControl';
import {
  MapContainer,
  TileLayer,
  Marker,
  Popup,
  Circle,
  Polygon
} from 'react-leaflet';

// デフォルトマーカー画像設定
import markerIcon2x from 'leaflet/dist/images/marker-icon-2x.png';
import markerIcon from 'leaflet/dist/images/marker-icon.png';
import markerShadow from 'leaflet/dist/images/marker-shadow.png';

delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: markerIcon2x,
  iconUrl: markerIcon,
  shadowUrl: markerShadow,
});

const MapView = ({
  selectedPolygons,
  selectedDate,
  period,
  onDatePeriodChange,
}) => {
  const [typhoonData, setTyphoonData] = useState(null);

  useEffect(() => {
    if (!selectedDate || !period) return;

    const baseDate = new Date(selectedDate);
    const hoursForDec = ['00', '03', '06'];
    const hoursForAsc = ['12', '15', '18'];

    // 対象の時間帯を選択
    const hours = period === 'am' ? hoursForDec : hoursForAsc;

    const targets = hours.map((hour) => {
      const d = new Date(baseDate);
      return { date: d, hour };
    });

    const filePaths = targets.map(({ date, hour }) => {
      const yyyymmdd = date.toISOString().slice(0, 10).replace(/-/g, '');
      return `/data/typhoon/${yyyymmdd}${hour}.json`;
    });

    console.log('台風データ読み込み:', filePaths);

    // JSONを安全に読み込む関数
    const safeFetchJson = async (path) => {
      try {
        const res = await fetch(path);
        if (!res.ok) return null; // 404や500など
        const text = await res.text();
        if (!text) return null; // 空ファイルの場合
        return JSON.parse(text);
      } catch (err) {
        console.warn(`ファイル取得失敗: ${path}`, err);
        return null;
      }
    };

    Promise.all(filePaths.map((path) => safeFetchJson(path)))
      .then((results) => {
        const validData = results.filter(Boolean);
        if (validData.length === 0) {
          setTyphoonData(null);
          return;
        }

        const merged = {
          type: 'FeatureCollection',
          features: validData.flatMap((d) => d.features || []),
        };
        setTyphoonData(merged);
      })
      .catch((err) => {
        console.error('台風データのロード中にエラー:', err);
        setTyphoonData(null);
      });
  }, [selectedDate, period]);

  return (
    <MapContainer center={[25, 130]} zoom={5} style={{ height: '100%', width: '100%' }}>
      <TileLayer
        url="https://cyberjapandata.gsi.go.jp/xyz/std/{z}/{x}/{y}.png"
        attribution='&copy; <a href="https://maps.gsi.go.jp/">国土地理院</a>'
      />

      {/* カレンダー＋午前午後切替 */}
      <DatePeriodControl
        selectedDate={selectedDate}
        period={period}
        onChange={onDatePeriodChange}
      />

      {/* 台風描画 */}
      {typhoonData &&
        typhoonData.features
          // 「properties.name」が存在する台風のみ表示
          .filter(
            (feature) =>
              feature.properties &&
              feature.properties.name &&
              feature.geometry?.type === 'Point'
          )
          .map((feature, idx) => {
            const { geometry, properties } = feature;
            const [lng, lat] = geometry.coordinates;

            return (
              <React.Fragment key={idx}>
                {properties.radius_km && (
                  <Circle
                    center={[lat, lng]}
                    radius={properties.radius_km * 1000}
                    pathOptions={{ color: 'red', fillOpacity: 0.3 }}
                  />
                )}
                <Marker position={[lat, lng]}>
                  <Popup>
                    {properties.name} / {properties.name_kana}
                    <br />
                    台風{properties.name_number}号
                    <br />
                    {properties.datetime} 時点
                    <br />
                    緯度 {lat}度
                    <br />
                    経度 {lng}度
                  </Popup>
                </Marker>
              </React.Fragment>
            );
          })}
      {/* 選択されたポリゴン描画 */}
      {selectedPolygons && selectedPolygons.map((polygon, idx) => (
        <Polygon
          key={`selected-polygon-${idx}`}
          positions={polygon}
          pathOptions={{ color: 'blue', fillOpacity: 0.4 }}
        />
      ))}
    </MapContainer>
  );
};

export default MapView;
